module.exports = "/_next/static/images/76e3e2255f62f700f6259659b785afb8-mgm-invite-ticket-3.jpg.webp";